import { AlertAppID, AlertToken } from "../redux/alerts/index";
import {
  ResidentActivityType,
  SubActivityType,
} from "../redux/residentActivityPlan";

export const alertIcon = (
  appid: AlertAppID,
  active = true,
  badgeNumber: number = undefined
): JSX.Element => {
  let iconName = "";
  switch (appid) {
    case AlertAppID.BTThresholds: {
      iconName = "icon-alert-thermometer danger";
      break;
    }
    case AlertAppID.HRThresholds: {
      iconName = "icon-alert-heart danger";
      break;
    }
    case AlertAppID.RRThresholds: {
      iconName = "icon-alert-respiration danger";
      break;
    }
    case AlertAppID.SpO2Thresholds: {
      iconName = "icon-alert-oxigen danger"; //not added yet
      break;
    }
    case AlertAppID.EpilepsyDetection: {
      iconName = "icon-alert-epilepsy danger"; //not added yet
      break;
    }
    case AlertAppID.PressureUlcers: {
      iconName = "icon-alert-turn info";
      break;
    }
    case AlertAppID.Fall: {
      iconName = "icon-alert-fall-prevention danger";
      break;
    }
    case AlertAppID.FallDetected: {
      iconName = "icon-alert-fall-detected danger";
      break;
    }
    case AlertAppID.BPThresholds: {
      iconName = "icon-alert-BloodPressure danger";
      break;
    }
    case AlertAppID.CallButton: {
      iconName = "icon-alert-call-button danger";
      break;
    }
    case AlertAppID.InBed: {
      iconName = "icon-alert-bed-in danger";
      break;
    }
    case AlertAppID.OutOfBed: {
      iconName = "icon-alert-bed-out danger";
      break;
    }
    case AlertAppID.AwayFromBed: {
      iconName = "icon-alert-bed-away-from-bed danger";
      break;
    }
    case AlertAppID.UserNearby: {
      iconName = "icon-alert-user-nearby-room-WW black";
      break;
    }
    // case AlertAppID.PowerUnplugged: {
    //     iconName = 'icon-alert-unplugged info';
    //     break;
    // }
    // case AlertAppID.WrongDevicePlacement: {
    //     iconName = 'icon-alert-wrong-device-placement info';
    //     break;
    // }
    // case AlertAppID.NoWiFi: {
    //     iconName = 'icon-alert-wi-fi-off info';
    //     break;
    // }
  }
  return badgeNumber !== undefined ? (
    <div className={`alert ${active ? "" : "disabled"}`}>
      <i className={iconName} />
      <div className="badge">{badgeNumber}</div>
    </div>
  ) : (
    <i className={iconName} />
  );
};

export const alertIconToken = (
  token: AlertToken,
  active = true,
  badgeNumber: number = undefined
): JSX.Element => {
  let iconName = "";
  switch (token) {
    case AlertToken.BTBelow:
    case AlertToken.BTAbove: {
      iconName = "icon-alert-thermometer danger";
      break;
    }
    case AlertToken.HRBelow:
    case AlertToken.HRAbove: {
      iconName = "icon-alert-heart danger";
      break;
    }
    case AlertToken.RRAbove:
    case AlertToken.RRBelow: {
      iconName = "icon-alert-respiration danger";
      break;
    }
    case AlertToken.SpO2Above:
    case AlertToken.SpO2Below: {
      iconName = "icon-alert-oxigen danger"; //not added yet
      break;
    }
    case AlertToken.EpilepsyDetection: {
      iconName = "icon-alert-epilepsy danger"; //not added yet
      break;
    }
    case AlertToken.TurnResident:
    case AlertToken.ResidentTurned: {
      iconName = "icon-alert-turn info";
      break;
    }
    case AlertToken.Fall: {
      iconName = "icon-alert-fall-prevention danger";
      break;
    }
    case AlertToken.FallDetected: {
      iconName = "icon-alert-fall-detected danger";
      break;
    }
    case AlertToken.PowerUnplugged: {
      iconName = "icon-alert-unplugged info";
      break;
    }
    case AlertToken.WrongDevicePlacement: {
      iconName = "icon-alert-wrong-device-placement info";
      break;
    }
    case AlertToken.NoWiFi: {
      iconName = "icon-alert-wi-fi-off info";
      break;
    }
    case AlertToken.CallButton: {
      iconName = "icon-alert-call-button danger";
      break;
    }
    case AlertToken.BPAbove:
    case AlertToken.BPBelow: {
      iconName = "icon-alert-BloodPressure danger";
      break;
    }
    case AlertToken.InBed: {
      iconName = "icon-alert-bed-in danger";
      break;
    }
    case AlertToken.OutOfBed: {
      iconName = "icon-alert-bed-out danger";
      break;
    }
    case AlertToken.AwayFromBed: {
      iconName = "icon-alert-bed-away-from-bed danger";
      break;
    }
    case AlertToken.UserNearby: {
      iconName = "icon-alert-user-nearby-room-WW black";
      break;
    }
  }
  return badgeNumber !== undefined ? (
    <div className={`alert ${active ? "" : "disabled"}`}>
      <i className={iconName} />
      <div className="badge">{badgeNumber}</div>
    </div>
  ) : (
    <i className={iconName} />
  );
};

export const alertTokenToSound = (value: AlertToken): string => {
  switch (value?.toLowerCase()) {
    case AlertToken.BTAbove.toLowerCase():
      return "BTAbove.mp3";
    case AlertToken.BTBelow.toLowerCase():
      return "BTBelow.mp3";
    case AlertToken.HRAbove.toLowerCase():
      return "HRAbove.mp3";
    case AlertToken.HRBelow.toLowerCase():
      return "HRBelow.mp3";
    case AlertToken.RRAbove.toLowerCase():
      return "RRAbove.mp3";
    case AlertToken.RRBelow.toLowerCase():
      return "RRBelow.mp3";
    case AlertToken.SpO2Above.toLowerCase():
      return "SpO2Above.mp3";
    case AlertToken.SpO2Below.toLowerCase():
      return "SpO2Below.mp3";
    case AlertToken.EpilepsyDetection.toLowerCase():
      return "epilepsy_detected.mp3";
    case AlertToken.TurnResident.toLowerCase():
      return "TurnResident.mp3";
    case AlertToken.ResidentTurned.toLowerCase():
      return undefined;
    case AlertToken.Fall.toLowerCase():
      return "Fall.mp3";
    case AlertToken.FallDetected.toLowerCase():
      return "Fall_Detected.mp3";
    case AlertToken.PowerUnplugged.toLowerCase():
      return "DrinkingRemider.mp3";
    case AlertToken.AwayFromBed.toLowerCase():
      return "AwayFromBed.mp3";
    case AlertToken.InBed.toLowerCase():
      return "InBed.mp3";
    case AlertToken.OutOfBed.toLowerCase():
      return "OutOfBed.mp3";
    case AlertToken.BPAbove.toLowerCase():
      return "BPAbove.mp3";
    case AlertToken.BPBelow.toLowerCase():
      return "BPBelow.mp3";
    case AlertToken.CallButton.toLowerCase():
      return "CallButton.mp3";
    default:
      return value + ".mp3";
  }
};

export const nearbyInGG = (): JSX.Element => {
  return (
    <i className="icon-user-nearby-in-GG">
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
      <span className="path5"></span>
      <span className="path6"></span>
      <span className="path7"></span>
    </i>
  );
};

export const nearbyOutGG = (): JSX.Element => {
  return (
    <i className="icon-user-nearby-out-GG">
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
    </i>
  );
};
export const nearbyRoomGG = (): JSX.Element => {
  return (
    <i className="icon-user-nearby-room-GG">
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
    </i>
  );
};

export const iconMeasurement = (el: SubActivityType): string => {
  switch (el) {
    case SubActivityType.SPO2: {
      return "icon-alert-oxigen";
    }
    case SubActivityType.HEART_RATE: {
      return "icon-alert-heart";
    }
    case SubActivityType.BLOOD_PRESSURE: {
      return "icon-alert-BloodPressure";
    }
    case SubActivityType.TEMPERATURE: {
      return "icon-alert-thermometer";
    }
  }
  return "";
};

export const borderByToken = (
  el: AlertToken | ResidentActivityType
): string => {
  const isReminder = Object.values(AlertToken).indexOf(el as AlertToken) === -1;
  if (isReminder) return "yellow";
  if (el === AlertToken.UserNearby) return "black";
  if (el === AlertToken.TurnResident) return "yellow";
  return "red";
};
